/**
 * Define our route selectable stylesheets
 *
 * @type {Object}
 */
const stylesheets = {
  quasar: 'css/quasar.css',
  bootstrap: 'css/bootstrap.css',
}

/**
 * Set the default fallback stylesheet
 * @type {[type]}
 */
const defaultStylesheet = stylesheets.public

const cssElement = document.getElementById('stylesheet')

export default function stylesheet(to, from, next) {

  if (to.meta.stylesheet !== from.meta.stylesheet) {
    cssElement.href = process.env.PUBLIC_PATH + (stylesheets[to.meta.stylesheet] || defaultStylesheet)
  }
}
